var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopic3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2464 38.6868C51.2464 38.6157 51.25 28.1244 51.25 28.1244L35.625 20.3125L20 28.125V38.4738C19.9939 44.9545 23.233 51.008 28.6282 54.5987L35.625 59.2612L41.015 55.6708C43.9282 59.4025 48.9606 60.7541 53.3515 58.9844C57.7426 57.2147 60.4312 52.7515 59.9429 48.0426C59.4544 43.3334 55.907 39.5172 51.2464 38.6862V38.6868ZM35.625 57.7612L29.3219 53.5599C24.274 50.2008 21.2436 44.537 21.25 38.4738V28.8974L35.625 21.7099L50 28.8974V38.5431C49.7925 38.5306 49.5868 38.5114 49.375 38.5114C49.1632 38.5114 48.9569 38.5306 48.75 38.5431C48.75 38.5199 48.75 29.6683 48.75 29.6683L35.625 23.1064L22.5 29.6689V38.4738C22.4954 44.1187 25.3168 49.3909 30.0156 52.5186L35.625 56.2561L39.7138 53.5318C39.8886 53.9133 40.0861 54.2841 40.3049 54.642L35.625 57.7612ZM39.2462 52.3419L35.625 54.7543L30.7095 51.4789C30.4669 51.3168 30.2319 51.1469 30 50.9726V45.3864H28.75V49.9237C28.064 49.2877 27.4365 48.591 26.875 47.8424V44.2105C26.8753 43.3511 27.4597 42.6019 28.2932 42.3926L32.5317 41.33C32.6679 42.6852 33.6667 43.7955 35 44.0738V46.6364H36.25V44.0738C37.5833 43.7958 38.5819 42.6852 38.7177 41.33L41.5 42.0288C38.9633 44.8184 38.1046 48.7479 39.2462 52.3413V52.3419ZM32.5 33.5114H34.2276C35.1923 33.5101 36.145 33.2965 37.0181 32.8864H37.1875L38.75 34.9695V37.5739L36.6669 39.1364H34.5831L32.5 37.5739V33.5114ZM31.3019 32.2614C31.4285 31.4777 31.9275 30.8041 32.6407 30.455C34.0231 29.8398 35.5808 29.7418 37.0294 30.1788L37.1732 30.3864H38.125C38.4702 30.3864 38.75 30.6662 38.75 31.0114V32.8864L37.8125 31.6364H36.7276L36.5958 31.702C35.86 32.0685 35.0494 32.2601 34.2276 32.2614H31.3019ZM37.5 40.0739V41.0114C37.5 42.0468 36.6605 42.8864 35.625 42.8864C34.5895 42.8864 33.75 42.0468 33.75 41.0114V40.0739L34.1669 40.3864H37.0831L37.5 40.0739ZM38.75 40.0494V39.1364L40 38.1989V31.0114C40 29.9756 39.1605 29.1364 38.125 29.1364H37.7094C36.8051 28.5867 34.5538 28.4756 32.9593 28.9743C31.1713 29.4135 29.9362 31.0461 30 32.8864V33.5114H31.25V38.1989L32.5 39.1364V40.0464L27.9889 41.1807C26.5985 41.5277 25.6235 42.7777 25.625 44.2105V45.8981C24.3933 43.6176 23.7488 41.066 23.75 38.4738V30.4413L35.625 24.5038L47.5 30.4413V38.4738C47.5 38.5455 47.4957 38.6169 47.4951 38.688C45.6723 39.014 43.9673 39.8126 42.5501 41.0043L38.75 40.0494ZM49.375 58.5114C44.1974 58.5114 40 54.314 40 49.1364C40 43.9584 44.1974 39.7614 49.375 39.7614C54.5526 39.7614 58.75 43.9584 58.75 49.1364C58.7442 54.3115 54.5502 58.5052 49.375 58.5114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 31.0114H60V32.2614H52.5V31.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 33.5114H57.5V34.7614H52.5V33.5114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 36.0114H55V37.2614H52.5V36.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0731 48.6945L44.8639 46.485L41.3281 50.0201L47.0731 55.7651L56.7957 46.0425L53.2599 42.5076L47.0731 48.6945ZM47.0731 53.9975L43.0957 50.0201L44.8639 48.2526L47.0731 50.4617L53.2605 44.2743L55.0287 46.0419L47.0731 53.9975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF66BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic3);
export default __webpack_public_path__ + "static/media/topic-3.b0be4441ffde700a64ceb0de6516e77e.svg";
export { ForwardRef as ReactComponent };